/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ErrorResponse } from 'react-router-dom';
import type { ZodError } from 'zod';

import type { CustomJsonResponse } from '@fai/third-party/react-router-dom';
import { reportZodErrorToSentry, reportLoaderErrorToSentry } from '@fai/third-party/sentry';

import ErrorPage from './error-page';

export function ValidationErrorPage({ error }: { error: ZodError }) {
  const { t } = useTranslation();
  React.useEffect(() => {
    reportZodErrorToSentry(error);
  }, [error]);

  return (
    <ErrorPage
      message={t('error.we_track_these_error')}
      title={t('error.looks_like_something_wrong')}
    />
  );
}

export function CustomJsonErrorPage({ error }: { error: CustomJsonResponse }) {
  const { t } = useTranslation();
  React.useEffect(() => {
    reportLoaderErrorToSentry(error);
  }, [error]);

  return (
    <ErrorPage
      message={t('error.we_track_these_error')}
      title={t('error.looks_like_something_wrong')}
    />
  );
}

export function ErrorResponsePage({ error }: { error: ErrorResponse }) {
  const { t } = useTranslation();
  React.useEffect(() => {
    reportLoaderErrorToSentry(error);
  }, [error]);

  return (
    <ErrorPage
      message={t('error.we_track_these_error')}
      title={t('error.looks_like_something_wrong')}
    />
  );
}
